<app-widget [titleT]="'FILE-PROCESS.cockpit.' + processType + '.title'" [navigateLink]="navigateLink$ | async"
    [navigateLink]="['/', 'customer-spaces', customerSpaceId, 'fiduciary', 'tasks']"
    [itemsCount]="(totalCount$ | async)!" [loading]="(loadingService.loading$ | async)!">
    <div *appShowAuthorize="'APP_TASKS_WRITE'" class="slot-action-button">
    </div>

    <app-display-legal-entities-without-processes [customerSpaceId]="customerSpaceId" [processType]="processType"
        [legalEntities]="(legalEntities2$ | async)!" [cockpitProcess$]="cockpitProcess$" />
    <app-processes-widget-table *ngIf="(cockpitProcess$ | async)!.length !== 0" [customerSpaceId]="customerSpaceId"
        [displayRowsCount]="displayRowsCount" [processes$]="cockpitProcess$"></app-processes-widget-table>
    <a *ngIf="showAll$ | async" [routerLink]="navigateLink$ | async" class="slot-footer">{{
        'FILE-PROCESS.cockpit.' + this.processType + '.show-all-link' | translate }}</a>
</app-widget>